import type { CanDeactivateFn } from '@angular/router'
import type RoutesPage from './routes.page'

// Warns before navigating away from the routes page (e.g. via the side
// nav) while a route or schedule is being created/edited.
export const routesPageCanDeactivateGuard: CanDeactivateFn<RoutesPage> =
  component => component.canDeactivate()
